import styled from 'styled-components';

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  .details-row {
    display: flex;
    justify-content: space-between;
    height: 44px;
    
    .overview-container {
      height: 44px;
      display: flex;
      justify-content: space-between;
      gap: 16px;
      
      .preview-container {
        display: flex;
        gap: 16px;
      }

      .avatar {
        height: 44px;
        width: 44px;
      }
    }
    
    .actions-container {
      width: 600px;
    }
  }
  
  .tags-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }
`;

export default HeaderWrapper;
